import { ThunkResult, Utilities } from "../../shared/utilities";
import { State } from "../model/State";
import { fetchItems, receiveUserSnippets } from "./FetchDataItems";

export const SNIPPETS_ENDPOINT = "api/snippets";

export function createSnippet(userSnippet: UserSnippet): ThunkResult<void, State> {
    return async (dispatch) => {
        try {
            const response = await Utilities.postJsonAndParseResponse<string>(SNIPPETS_ENDPOINT, userSnippet);
            dispatch(fetchItems(SNIPPETS_ENDPOINT, receiveUserSnippets));
            Utilities.toastSuccess(response);
        } catch (err) {
            Utilities.toastError(err);
            console.error(err);
        }
    };
}

export function editSnippet(newSnippet: string, isShared: boolean, id: number): ThunkResult<void, State> {
    return async (dispatch) => {
        try {
            const response = await Utilities.patchJsonAndParseResponse<string>(`${SNIPPETS_ENDPOINT}/${id}`, { snippet: newSnippet, isShared });
            dispatch(fetchItems(SNIPPETS_ENDPOINT, receiveUserSnippets));
            Utilities.toastSuccess(response);
        } catch (err) {
            Utilities.toastError(err);
            console.error(err);
        }
    };
}
export function deleteSnippet(id: number): ThunkResult<void, State> {
    return async (dispatch) => {
        try {
            const response = await Utilities.deleteFetchAndParseResponse<string>(`${SNIPPETS_ENDPOINT}/${id}`);
            dispatch(fetchItems(SNIPPETS_ENDPOINT, receiveUserSnippets));
            Utilities.toastSuccess(response);
        } catch (err) {
            Utilities.toastError(err);
            console.error(err);
        }
    };
}

export interface UserSnippet {
    id?: number;
    name: string;
    isShared: boolean;
    languageMode: string;
    owner?: string;
    modifiedUtc?: string;
    snippet: string;
}